var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcBrandFacebookSolid = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 2c5.523 0 10 4.505 10 10.061 0 5.022-3.657 9.184-8.437 9.939v-7.03h2.33l.443-2.909h-2.773v-1.926c.012-.782.407-1.532 1.63-1.532h1.26V6.126s-1.144-.197-2.238-.197c-2.267 0-3.754 1.371-3.777 3.856v2.275h-2.54v2.908h2.54V22C5.657 21.245 2 17.083 2 12.061 2 6.505 6.477 2 12 2",
  clipRule: "evenodd"
})));
export default SvgIcBrandFacebookSolid;